import React from "react";
import Hero from "@/components/site/Hero";
import CountdownBanner from "@/components/site/CountdownBanner";
import FreeHighlight from "@/components/site/FreeHighlight";
import VenueInfo from "@/components/site/VenueInfo";
import Schedule from "@/components/site/Schedule";
import RegistrationForm from "@/components/site/RegistrationForm";
import Footer from "@/components/site/Footer";

export default function LandingPage() {
    return (
        <main className="min-h-screen bg-cream-50" data-testid="landing-page">
            <Hero />
            <CountdownBanner />
            <FreeHighlight />
            <VenueInfo />
            <Schedule />
            <RegistrationForm />
            <Footer />
        </main>
    );
}
